import Center from "../../assets/images/product/facadeEco/center.webp";
import Left from "../../assets/images/product/facadeEco/left.webp";
import FacadeEco from "../../assets/images/products/facadeEco.webp";
import { categoriesOfPaints } from "../categoryOfPaints";

export const plasterSil = {
  category: [categoriesOfPaints.textured],
  path: "festek_plaster_sil",
  name: "FESTEK-PLASTER SIL",
  header: "Штукатурка силиконовая защитно-декоративная «FESTEK-PLASTERSIL»",
  link: "https://drive.google.com/file/d/1-shjYLMDGnKRBo4vZvecX2Cj08cpSKoG/view?usp=drive_link",
  purchase: [
    {
      price: "150,00",
      amount: "25 кг",
    },
  ],
  productsPage: {
    title: "Штукатурка силиконовая защитно-декоративная «FESTEK-PLASTERSIL»",
    text: "Высокая стойкость к влаге, ультрафиолету и механическим повреждениям, паропроницаемая, предотвращает появление плесени. Камешковая фактура, фракция 1,0 1,5 2,0",
  },
  images: {
    products: FacadeEco,
    product: [Center, Left],
  },
  documentation: {
    description: {
      concept: {
        value:
          "это штукатурка предназначена для защиты и декорирования внешних стен зданий бетонных, кирпичных, оштукатуренных, а также в системе утепления. Создает декоративное рельефное покрытие, не требующее дополнительной отделки. При изготовление используются светостойкие пигменты, поэтому покрытие устойчиво к выцветанию. Силиконовое связующее придает покрытию водоотталкивающие свойства, устойчивость к загрязнениям, что обеспечивает ее долгий срок службы.",
        label:
          "Штукатурка силиконовая защитно-декоративная «Festek-PlasterSil»",
      },

      properties: {
        value: [
          "Для наружных работ.",
          "Стойкая к атмосферным воздействиям, устойчива к выцветанию, что обеспечивает долгий срок службы покрытия.",
          "Высокая паропроницаемость и низкое водопоглощение.",
          "Содержит биоцид от плесени и грибка.",
          "Эластичная.",
          "Готовая к применению «Камешковой» фактуры.",
        ],
        label: "Преимущество",
        note: [
          "*Прогнозируемый срок службы покрытия при соблюдении технологии нанесения в комплексе с грунтовками – не менее 15 лет.",
        ],
      },

      consumption: {
        value:
          "Ориентировочный расход - с размером частиц структурного наполнителя 1,0 мм - 1,8-2,2 кг/м2, 1,5 мм - 2,5-3,0 кг/м2; 2,0 мм - 3,1-3,5 кг/м2. Расход зависит от состояния и подготовки поверхности, квалификации персонала и более точно определяется путем нанесения пробного покрытия.",
        label: "Расход",
      },

      package: {
        value: "20 литров – 25 килограмм.",
        label: "Упаковка",
      },

      suitableSubstrates: {
        value:
          "Бетон (возраст не менее 3 месяцев влажность не более 4%), цементно-известковые, цементно-песчаные штукатурки (возраст не менее 28 дней влажность не более 4%), основание для систем утепления и другие клеящие составы.",
        label: "Пригодные подложки",
      },

      coatingSystem: {
        value:
          'За 24 часа до нанесения штукатурки для достижения равномерного оптического эффекта и улучшения адгезии рекомендуется нанести грунтовку "Festek Maxi-Grunt", тонированную в цвет штукатурки.',
        label: "Система покрытия",
      },

      colorSolutions: {
        value:
          "Белый + цвета по большинству колеровочных системы. Возможен подбор цвета по вашему образцу. Богатую палитру цветов можете выбрать у нас сайте",
        label: "Цветовые решения",
      },
    },

    applicationTechnology: {
      composition: {
        value:
          "Вода, акриловая дисперсия, силиконовая эмульсия, пигменты, наполнители и функциональные добавки.",
        label: "Состав",
      },

      preparationSurfaces: {
        value:
          'На здание должна быть установлена водосточная система, подоконные отливы и закрытые парапеты крыш. Поверхность должна быть чистой, сухой (остаточная влажность не более 6%), ровной. Основание не должно содержать отслаивающихся или слабосодержащих покрытий. Сильно впитывающие и мелящие поверхности следует загрунтовать грунтовкой «Festek-Grunt». За 24 часа до нанесения штукатурки для достижения равномерного оптического эффекта и улучшения адгезии рекомендуется нанести грунтовку "Festek Maxi-Grunt", тонированную в цвет штукатурки.',
        label: "Подготовка поверхности",
      },

      methodAndConditionsDrawing: {
        value:
          "Не выполнять работы под прямыми солнечными лучами, при сильном ветре, дожде и при температуре не ниже 10°С и или относительной влажности не более 80 %. Перед применением тщательно перемешать. При необходимости допускается разбавление водой: не более 1% при нанесении вручную, не более 2% - при пневмораспылении. Толщина слоя должна соответствовать размеру зерна наполнителя. Спустя некоторое время, когда материал перестанет прилипать к инструменту, формируют фактуру покрытия при помощи пластиковой терки легким скользящим движением, избегая нажима на штукатурный слой. На одной поверхности работы следуют выполнять без перерыва, сохраняя одинаковую консистенцию материала. В случае перерыва, начинать работу от края участка, предварительно защитив малярной лентой ранее нанесенный край штукатурки. Инструмент, тару, пятна штукатурки отмыть теплой водой с мылом до высыхания штукатурки.",
        label: "Способ и условия нанесения",
      },

      temperature: {
        value:
          "Во время нанесения и в процессе высыхания температура воздуха и основания не должна опускаться ниже +10°C и подниматься выше +30°C. Не работать под воздействием прямых солнечных лучей, при сильном ветре, тумане или высокой влажности воздуха. Время сушки При температуре +20 °C и относительной влажности воздуха 65% через 24 часа поверхность сухая. Через 2-3 дня поверхность может подвергаться нагрузке и дальнейшей обработке.",
        label: "Температурный режим, время высыхания",
      },

      endlessApplication: {
        value:
          "Штукатурку можно наносить механизированным способом при помощи картушного пневматического пистолета размер сопла 4-6 мм. (при рабочем давлении 4-6 атм.)",
        label: "Безвоздушное нанесение",
      },
    },

    technicalData: [
      {
        qualityIndicators: "Цвет покрытия",
        value: "Соотв.",
      },
      {
        qualityIndicators:
          "Прочность сцепления покрытия с основанием, МПА не менее",
        value: "0,8",
      },
      {
        qualityIndicators:
          "Условная светостойкость покрытия за 24 часа (изменение коэффициента диффузного отражения), %, не более",
        value: "5",
      },
      {
        qualityIndicators:
          "Коэффициент паропроницаемости, мг/ (м ч Па), не менее",
        value: "0,01",
      },
      {
        qualityIndicators:
          "Водопоглощение покрытия при капиллярном подсосе, кг/м2, не более",
        value: "1,0",
      },
      {
        qualityIndicators: "Морозостойкость покрытия, циклы, не менее",
        value: "50",
      },
      {
        qualityIndicators: "Атмосферостойкость покрытия, циклы, не менее",
        value: "100",
      },
      {
        qualityIndicators: "Усадка покрытия:",
        value: "отсутствие трещин в слое толщиной, мм",
      },
      {
        qualityIndicators: "Для штукатурки с размером зерна 1,5",
        value: "3",
      },
      {
        qualityIndicators: "Для штукатурки с размером зерна 2,0",
        value: "4",
      },
      {
        qualityIndicators:
          "Срок службы покрытия в условиях эксплуатации У1, лет, не менее",
        value: "15",
      },
    ],
  },
};
